export default __webpack_public_path__ + "static/media/elephant.8bc311ff.jpg";